export default "__VITE_PUBLIC_ASSET__2ce5b9d2__"